export function isValidCPF(cpf) {
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

    let soma = 0;
    for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
    let resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;

    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    return resto === parseInt(cpf.charAt(10));
}

export function isValidPassword(password) {
    // if (!/^\d+$/.test(password)) {
    //     return "Senha inválida: deve conter apenas números.";
    // } else
    if (/(.)\1/.test(password)) {
        return "Senha inválida: não pode conter números repetidos consecutivos.";
    } else if (/(01|12|23|34|45|56|67|78|89)/.test(password)) {
        return "Senha inválida: não pode conter sequências numéricas (ex: 12, 23, 34).";
    }

    return null;
}